<template>
  <div>
    <div class="list_wrap flex flex_wrap">
      <div class="list" v-for="(item, index) in list" :key="index">
        <div class="list_top flex flex_content_sb flex_items_center">
          <div class="item_img">
            <el-image class="img" :src="item.avatar_image"></el-image>
            <img
              class="authentication"
              v-if="item.exhibitor_long_id"
              src="@/assets/authentication.png"
              alt=""
            />
          </div>
          <div class="list_info">
            <div class="list_name">
              <span class="name">{{ item.name }}</span
              >{{ item.duty }}
            </div>
            <div>{{ item.company }}</div>
          </div>
        </div>
        <div class="list_main">
          {{ item.response_content }}
        </div>
        <div class="list_bottom flex flex_content_sb">
          <p>{{ item.create_time }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "replyList",
  props: ["list"],
  data() {
    return {
      langSet: ''
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.list_wrap {
  .list {
    width: calc((100% - 40px) / 3);
    height: auto;
    color: #555;
    font-size: 16px;
    line-height: 24px;
    padding: 20px 20px 0;
    background: #f7f8fa;
    box-sizing: border-box;
    margin-right: 20px;
    margin-bottom: 20px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    .list_top {
      margin-bottom: 15px;
      .item_img {
        width: 65px;
        height: 65px;
        position: relative;
        .img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .authentication{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 20px;
          height: 20px;
        }
      }
      .list_info {
        flex: 1;
        font-size: 15px;
        color: #7a7e93;
        padding-left: 10px;
        .list_name {
          color: #000;
          .name {
            font-size: 18px;
            font-weight: 500;
            margin-right: 10px;
          }
        }
      }
    }
    .list_main {
      height: 100px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4; /* 控制显示行数 */
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word; /* 处理长单词或URL */
      margin-bottom: 10px;
    }
    .list_bottom {
      color: #888;
      font-size: 14px;
      line-height: 40px;
      border-top: 1px dashed #ddd;
    }
  }
}
@media only screen and (max-width: 767px) {
  .list_wrap .list{
    width: 100%;
    margin-right: 0;
  }
}
</style>